module.exports = __webpack_public_path__ + "static/media/stamp_12.42167dd5.png";